<div class="assessment-duration-calendar">
        <cygov-ngb-calendar [selectedDate]="selectedStartDate"
                [isCalendarDisabled]="disableStartDate || disableAll===3"
                [inputMinDate]="allowPastStartDate ? null : currentDateSet" [dateType]="'startDate'"
                [isCalendarDisabled]="disableAll===1 || disableAll===3"
                [inputMinDate]="currentDateSet" [dateType]="'startDate'"
                (selectedDateChange)="changeDate($event, 'startDate')"
                (calendarRef)="this.setCalendarRef($event, true)">
        </cygov-ngb-calendar>

        <cygov-ngb-calendar [selectedDate]="selectedEndDate"
                [isCalendarDisabled]="disableAll===2 || disableAll===3"
                [inputMinDate]="selectedStartDate" [dateType]="'endDate'"
                (selectedDateChange)="changeDate($event, 'endDate')"
                (calendarRef)="this.setCalendarRef($event, false)">
        </cygov-ngb-calendar>
</div>